export default __webpack_public_path__ + "static/media/limb_main_mobile_small.6d3abe86.jpg";